var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg021SgRealTimeData = function Svg021SgRealTimeData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20 20v432c0 22.091 17.909 40 40 40h432",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 372c0-4.409 1.752-8.637 4.869-11.754l125.128-125.104-1.716-1.715c-15.621-15.619-40.946-15.62-56.567-.001L100 365.114V372c0 22.091 17.909 40 40 40h60c-22.091 0-40-17.909-40-40z",
    fill: "#a0eda2",
    "data-original": "#cee1f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m104.869 360.246 126.846-126.822c15.621-15.618 40.946-15.617 56.566.003l23.432 23.432c15.622 15.622 40.95 15.621 56.571-.002L460 165.127V372c0 22.091-17.909 40-40 40H140c-22.091 0-40-17.909-40-40 0-4.409 1.752-8.637 4.869-11.754z",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#005454",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#0023c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100 252 131.716-131.716c15.621-15.621 40.948-15.621 56.569 0l23.431 23.431c15.621 15.621 40.948 15.621 56.569 0L420 92m-8-72h40c22.091 0 40 17.909 40 40v40",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#14d64d",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#ff5cf4"
  }));
};

export default Svg021SgRealTimeData;